import React from 'react';
import styled from 'styled-components';

import Button from '../global/button';
import Section from '../global/section';

const StyledOpener = styled.div`
	section {
		padding: 2rem 0;
	}
	.flex {
		display: flex;
		padding: 1rem;
		.left {
			width: 25%;
			h1,
			h2 {
				font-size: 1.4rem;
				line-height: 1.9rem;
			}
		}
		.middle {
			width: 45%;
			padding: 0 2rem;
		}
		.right {
			width: 35%;
			display: flex;
			align-items: center;
			a {
				font-size: 0.9rem;
				padding: 0 2rem;
			}
		}
		@media all and (max-width: 1050px) {
			flex-direction: column;
			width: 70%;
			margin: 0 auto;
			.left,
			.right {
				width: 100%;
			}
			.middle {
				padding: 1rem 0 2rem;
				width: 100%;
			}
		}
		@media all and (max-width: 668px) {
			width: 100%;
		}
		@media all and (max-width: 350px) {
			.right a {
				padding: 0 1.25rem;
				font-size: 0.9rem;
			}
		}
	}
`;

export default ({ data }) => {
	const { title, copy, cta } = data;
	return (
		<StyledOpener>
			<Section>
				<div className="flex">
					<div className="left">
						<h1>{title}</h1>
					</div>
					<div className="middle">
						<p>{copy}</p>
					</div>
					<div className="right">
						<Button type="link" bg="white" to={cta.link}>
							{cta.text}
						</Button>
					</div>
				</div>
			</Section>
		</StyledOpener>
	);
};
